import styled from "styled-components";
import { borderGrey, inter, primaryBlack, primaryPink } from "../../Theme";

function InputTextArea({name, label, description, ...props}) {
    return (
        <Wrapper>
            { label && <LabelWrapper><label htmlFor={name}>{label}</label></LabelWrapper> }
            { description && <Description>{description}</Description> }
            <Textarea
                id={name}
                name={name}
                rows={4}
                {...props}
            />
        </Wrapper>
    )
}

const Wrapper = styled.div`
`

const LabelWrapper = styled.div`
    font-family: ${inter};
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    color: ${primaryBlack};
    margin-bottom: 12px;
`

const Description = styled.div`
    font-family: ${inter};
    font-weight: 400;
    font-style: italic;
    color: ${primaryBlack};
    margin-bottom: 12px;
`

const Textarea = styled.textarea`
    width: 100%;
    font-family: ${inter};
    font-size: 16px;
    line-height: 21px;
    border: 1px solid ${borderGrey};
    padding: 10px;
    resize: none;

    &:focus-visible {
        outline-style: solid;
        outline-width: 2px;
        outline-color: ${primaryPink};
    }
`

export default InputTextArea;